var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reveal-view',[_c('h2',{staticClass:"title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Sūtīt ziņu")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('message-form',{attrs:{"recipient":_vm.recipient},on:{"sent":function($event){_vm.$modal.closeReveal()}}})],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d25f06c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/inbox/MessageReveal.vue
// module id = GRsn
// module chunks = 0